import { Link } from 'react-router-dom';

import { useTranslate } from '@tolgee/react';
import SOCIALS from '@webclient/layouts/main/sections/toolbar/socials/config';
import {
  StyledGradientButton,
  StyledStackSocials,
} from '@webclient/layouts/main/sections/toolbar/socials/styles';

export default function Socials() {
  const { t } = useTranslate();

  return (
    <StyledStackSocials
      gap={2}
      direction="row"
    >
      {SOCIALS.map(({ href, icon: SocialIcon, mappedLabel, defaultLabel }) => {
        return (
          <StyledGradientButton
            to={href}
            key={t(mappedLabel, defaultLabel)}
            target="_blank"
            component={Link}
            disableRipple
            disableTouchRipple
          >
            {SocialIcon}
            &nbsp;
            {t(mappedLabel, defaultLabel)}
          </StyledGradientButton>
        );
      })}
    </StyledStackSocials>
  );
}
